import { COUNTRY_CODES } from '../../common/constants';

export default function canShowDoNotSell(state, country) {
  // Do Not Sell link / form can only be shown to California residents
  return country === COUNTRY_CODES.USA && state === 'CA';
}
